<template>
  <div class="absolute bottom-0 w-screen h-10 border-gray-300 border-t flex items-center">
    <div class="ml-auto items-end mr-4">
      <a href="https://ambalytics.com/privacy-policy/" class="px-4">Privacy Policy</a>
      <a href="https://ambalytics.com/imprint/" class="px-4">Impressum</a>
    </div>
  </div>
</template>
